import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Toast } from 'app/shared/toast/toast';
import { IdexService } from 'app/idex.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { PasswordStrengthComponent } from 'app/shared/password-strength/password-strength';
import { AdminApi } from '../admin-api';
import { Router } from '@angular/router';

declare let $: any;
let message;
let message_dup;

export interface Transaction {
   id: string;
   name: string;
}

@Component({
   selector: 'app-add-user-company',
   templateUrl: './add-user-company.component.html',
   styleUrls: ['./add-user-company.component.css']
})

export class AddUserCompanyComponent implements OnInit {
   @ViewChild('fullName') fullName: ElementRef;
   roles = [
      {value: 'Admin', viewValue: 'admin'},
      {value: 'Editor', viewValue: 'editor'},
      {value: 'Moderator', viewValue: 'moderator'},
      {value: 'Member', viewValue: 'member'}
   ];

   currentRole = '';
   user: any;

   contIdValue = '';
   tin: string;
   datalist: any;
   flagSubmit = false;
   duplicateMember: any;
   contNamevalue = '';
   contEmailvalue = '';
   error_email = false;
   errorMessage: string;
   requireInputMessage: string;

   // create password
   @ViewChild(PasswordStrengthComponent) pwdStrength: PasswordStrengthComponent;
   password: string;
   conpass: string;
   minLength: number;
   maxLength: number;
   newError: string;

   loading: boolean;
   visible = false;
   visibleO = false;
   visibleC = false;

   firstname: string;
   lastname: string;
   username: string;
   email: string;
   quota: any;
   role = 'Member';
   isActive = true;
   isEdit = true;

   constructor(public toast: Toast,public router: Router,
      public service: IdexService,
      public adminService: AdminApi,
      public translate: TranslateService,
      @Inject(MAT_DIALOG_DATA) private data: any,
      private dialogRef: MatDialogRef<AddUserCompanyComponent>) {
         this.isEdit = data.isEdit
         this.username = data.username;
         this.tin = window.localStorage.getItem('tin');
         this.user = this.service.user;
         if (this.isEdit) {
            this.getProfile();
         }
   }

   ngOnInit() {
      this.service.get('api/password-policy')
         .subscribe(data => {
            this.minLength = data.minLength;
            this.maxLength = data.maxLength;
         });
      this.getUser();
      this.translate.get('alert.inputRequired').subscribe((msg) => {
         this.requireInputMessage = msg;
         message = msg;
      });
      this.translate.get('alert.not-match').subscribe((msg_dup) => {
         this.requireInputMessage = msg_dup;
         message_dup = msg_dup;
      });
   }

   // checkpassword
   eval(): void {
      if (this.password) {
         this.pwdStrength.eval(this.password, this.username, this.firstname + ' ' + this.lastname);
      }
   }

   getUser(): void {
      this.service.getUserList()
         .subscribe((data: any) => {
            this.datalist = data;
         });
   }

   getProfile(): void {
      this.adminService.getProfile(this.username,this.tin)
         .subscribe((data: any) => {
            this.username = this.username;
            this.firstname = data.firstname;
            this.lastname = data.lastname;
            this.password = data.password;
            this.conpass = data.password;
            this.email = data.email;
            this.isActive = data.active;
            this.quota = data.quota;
            this.role = data.role;
            this.currentRole = data.role;
         });
   }

   onkeyup(item) {
      const reg = /^[_A-Za-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      if (item.value.length === 0) {
         this.error_email = false;
         this.fullName.nativeElement.disabled = false;
         return;
      } else if (!reg.test(item.value)) {
         this.error_email = true;
         this.contNamevalue = '';
         this.fullName.nativeElement.disabled = false;
         return;
      } else {
         this.error_email = false;
         this.duplicateMember = false;
         for (let i = 0; i < this.datalist.length; i++) {
            if (this.datalist[i].email === item.value) {
               this.contNamevalue = this.datalist[i].firstname + '  ' + this.datalist[i].lastname;
               this.fullName.nativeElement.disabled = true;
               this.duplicateMember = true;
            }
         }
         if (!this.duplicateMember) {
            this.contNamevalue = '';
            this.fullName.nativeElement.disabled = false;
         }
      }
   }

   onSubmitUser(permission: any,username: any, firstname: any, lastname: any, email: any, password: any,quota: any) {
      this.flagSubmit = true;
      const data = {
         username: username.value.toLowerCase(),
         firstname: firstname.value.trim(),
         lastname: lastname.value === undefined ? '' : lastname.value.trim(),
         email: email.value.toLowerCase(),
         password: password.value,
         role: permission.selected.value,
         tin: this.tin,
         quota: parseInt(quota.value),
         active: this.isEdit ? this.isActive : true,
         edit: this.isEdit,
      }
      this.service.post('/signup/member?device=Web', data, { responseType: 'text' })
         .subscribe(
            _data => {
               this.dialogRef.close(true);
               this.toast.success(_data);
            },
         ).add(() => { 
            this.flagSubmit = false;
            if(this.isEdit && this.user.username === data.username) {
               if(this.currentRole === 'Admin' && data.role !== 'Admin') {
                  this.router.navigate(['/files']);
               }
            }
         });
   }

   InvalidMsg() {
      $('#form input[id=fullName]').on('change invalid', function () {
         const textfield = $(this).get(0);
         const contactName = textfield.value.trim();
         textfield.setCustomValidity('');
         if (contactName === '') {
            textfield.setCustomValidity(message);
            setTimeout(function () {
               textfield.setCustomValidity(' ');
            }, 1000);
         } else
            if ((/[<|>!\\\/~+#$&()\-_=,:?*;'."%^{}@[\]0123456789]/g.test(contactName))) {
               textfield.setCustomValidity(message_dup);
               setTimeout(function () {
                  textfield.setCustomValidity(' ');
               }, 1000);
            }
      });

      $('#form input[id=email]').on('change invalid', function () {
         const textfield = $(this).get(0);
         const contactName = textfield.value.trim();
         textfield.setCustomValidity('');
         if (contactName === '') {
            textfield.setCustomValidity(message);
            setTimeout(function () {
               textfield.setCustomValidity(' ');
            }, 1000);
         }
      });
   }

   keyPress(event: any) {
      const pattern = /[\-0-9]/;
  
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    }

   isEmpty(): boolean {
      const pattern = /^-1$|^[0-9]+$/;
      return this.quota === null || this.quota === undefined || this.quota === '' || this.quota === '0'
         || !pattern.test(this.quota);
   }

}
